import service from "@/utils/request";

// 获取导出信息
interface taskDetailData {
  task_id: number;
}
export const taskDetail = (params: taskDetailData) => {
  return service({
    url: "/api/v1/export/task/down",
    method: "get",
    params,
  });
};

// 添加导入任务
interface createImportTaskData {
  type: number;
  original_file_name: string;
  file_path: string;
}
export const createImportTaskApi = (data: createImportTaskData) => {
  return service({
    url: "/api/v1/import/task/create",
    method: "post",
    data,
  });
};

// 获取导入信息
interface taskImportDetailData {
  task_id: number;
}
export const latentImportErrorListApi = (params: taskImportDetailData) => {
  return service({
    url: "/api/v1/student/latent/import_error_list",
    method: "get",
    params,
  });
};

// 意向学员导入错误信息检测
export interface importErrorVerifyInter {
  student_name: string;
  area_code: string;
  mobile: string;
  wechat: string;
  recruit_staff?: string;
  market_staff?: string;
  appear: string;
  source: string;
  sex?: string;
  birthday?: string;
  follow_staff?: string;
  custody_staff?: string;
  spare_area_code?: string;
  spare_mobile?: string;
  address?: string;
  school?: string;
  subject?: string;
  remark?: string;
  is_potential?: string;
}
export const importErrorVerifyApi = (data: importErrorVerifyInter) => {
  return service({
    url: "/api/v1/student/latent/import_error_verify",
    method: "post",
    data,
  });
};
// 意向学员导入错误信息重新导入
export interface importErrorCreateInter {
  task_id: number;
  list: importErrorVerifyInter[];
}
export const importErrorCreateApi = (data: importErrorCreateInter) => {
  return service({
    url: "/api/v1/student/latent/import_error_create",
    method: "post",
    data,
  });
};
